import { render, staticRenderFns } from "./OverlayTimeEdit.vue?vue&type=template&id=c8bc45e4&"
import script from "./OverlayTimeEdit.vue?vue&type=script&lang=js&"
export * from "./OverlayTimeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8bc45e4')) {
      api.createRecord('c8bc45e4', component.options)
    } else {
      api.reload('c8bc45e4', component.options)
    }
    module.hot.accept("./OverlayTimeEdit.vue?vue&type=template&id=c8bc45e4&", function () {
      api.rerender('c8bc45e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayTimeEdit.vue"
export default component.exports